"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classnames = _interopRequireDefault(require("classnames"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function useFoxModalFullScreenProps(rest) {
  var style = rest.style,
    className = rest.className,
    token = rest.token,
    props = __rest(rest, ["style", "className", "token"]);
  var _ref = token || {},
    uiPaddingY = _ref.uiPaddingY,
    uiPaddingX = _ref.uiPaddingX;
  // eslint-disable-next-line arrow-body-style
  var modalExtendsProps = function () {
    return {
      width: 'var(--ui-fox-modal-width)',
      height: 'var(--ui-fox-modal-height)',
      centered: false,
      mask: true,
      style: (0, _extends2["default"])((0, _extends2["default"])({}, style), {
        '--ui-fox-modal-left': Array.isArray(uiPaddingX) ? uiPaddingX[0] : uiPaddingX,
        '--ui-fox-modal-right': Array.isArray(uiPaddingX) ? uiPaddingX[1] : uiPaddingX,
        '--ui-fox-modal-top': Array.isArray(uiPaddingY) ? uiPaddingY[0] : uiPaddingY,
        '--ui-fox-modal-bottom': Array.isArray(uiPaddingY) ? uiPaddingY[1] : uiPaddingY,
        top: "var(--ui-fox-modal-top)",
        left: "var(--ui-fox-modal-left)"
      }),
      wrapProps: {
        style: {
          lineHeight: 0
        }
      },
      className: (0, _classnames["default"])(className, 'ui-modal-full-screen'),
      getContainer: function getContainer() {
        return document.body;
      }
    };
  }();
  return (0, _extends2["default"])((0, _extends2["default"])({}, props), modalExtendsProps);
}
var _default = exports["default"] = useFoxModalFullScreenProps;